var _path, _mask, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 69,
    viewBox: "0 0 41 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5458 0L16.7339 32.4216H26.7088L40.2657 0H29.5458Z",
    fill: "#6359CF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 30,
    width: 36,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82373 30.4102H38.0011V68.9994H3.82373V30.4102Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2713 36.064V33.2416C14.2713 32.7827 14.6438 32.4089 15.1015 32.4089H26.7233C27.1811 32.4089 27.5536 32.7827 27.5536 33.2416V36.064C25.512 35.1996 23.2678 34.7216 20.9124 34.7216C18.557 34.7216 16.3128 35.1996 14.2713 36.064ZM29.5461 37.0661V33.241C29.5461 31.68 28.2797 30.4102 26.7233 30.4102H15.1015C13.5451 30.4102 12.279 31.68 12.279 33.241V37.0661C7.22034 40.042 3.82373 45.5534 3.82373 51.8602C3.82373 61.326 11.4744 68.9995 20.9124 68.9995C30.3502 68.9995 38.0011 61.326 38.0011 51.8602C38.0011 45.5534 34.6047 40.042 29.5461 37.0661Z",
    fill: "url(#paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9167 65.8891C13.1313 65.8891 6.79785 59.6728 6.79785 52.0317C6.79785 44.3901 13.1313 38.1738 20.9167 38.1738C28.7022 38.1738 35.036 44.3901 35.036 52.0317C35.036 59.6728 28.7022 65.8891 20.9167 65.8891Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3844 55.8248C25.4391 56.6025 24.6542 57.1646 23.9355 56.8622L21.1489 55.6899L18.3515 56.8365C17.6302 57.1322 16.8506 56.5631 16.9123 55.786L17.1553 52.7282L15.1939 50.3707C14.6985 49.7752 14.9997 48.8666 15.7528 48.6851L18.7075 47.9728L20.3027 45.3849C20.7134 44.7186 21.6836 44.7231 22.0883 45.3931L23.6601 47.9958L26.6084 48.7352C27.3597 48.9237 27.6526 49.835 27.1518 50.4259L25.1691 52.7651L25.3844 55.8248Z",
    fill: "#FFEFB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H11.9068L27.1923 32.9446H16.0104L0 0Z",
    fill: "#7367F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.2833,
    y1: 25.4252,
    x2: -3.25535,
    y2: 55.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.5531,
    y1: 33.0563,
    x2: 3.05261,
    y2: 55.1237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99912"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.49ba005e808cdc8d4c322bbef2873510.svg";
export { ForwardRef as ReactComponent };